import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';
import DashboardLineGraph from './ComponentFragments/DashboardLineGraph';

export default class TeamUnitsPerformance extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            teamData: [],
            yearData: [],
            segmentData: [],
            //toWeekData: [],
            selectedYear: 0,
            selectedSegment: 0,
            //selectedToWeek: 0,
            teamGraphData: {
                labels: [],
                currYTDSales: [],
                prevYTDSales: []
            },
            tableHidden: true
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleSegmentSelectChange = this.handleSegmentSelectChange.bind(this);
        this.getTeamPerformance = this.getTeamPerformance.bind(this);
    }

    async loadSegmentsForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getsegmentsforyear?yearId=' + year, 200);
        let segData = [];
        result.data.forEach((segment) => segData.push({ checked: false, value: segment.periodId, text: segment.description }));

        segData[0].checked = true;
        this.setState({
            segmentData: segData,
            //toWeekData: toWeeksData,
            selectedSegment: segData[0].value,
            //selectedToWeek: toWeeksData[0].value
        })

        this.props.loaderOff();
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadSegmentsForYear(selected[0])
    }

    handleSegmentSelectChange(selected) {
        this.setState({
            selectedSegment: selected[0]
        });
    }



    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let yearsData = [];
        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        let teamGraphData = {
            labels: [],
            currYTDSales: [],
            prevYTDSales: []
        }
        let graphResponse = await dl.Post('/common/GetGraphData', 1)

        graphResponse.data.forEach((entry) => {
            teamGraphData.labels.push(entry.month);
            teamGraphData.currYTDSales.push(entry.currYr);
            teamGraphData.prevYTDSales.push(entry.prevYr);
        })

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value,
            teamGraphData: teamGraphData
        })
        this.props.loaderOff();
    }

    async getTeamPerformance() {
        this.props.loaderOn();
        var dl = new DataLayer();
        await dl.Get('/teamleader/GetTeamUnitsPerformance?segmentId=' + this.state.selectedSegment, 200).then((response) => {
            let demRecs = [];
            let rec;

            response.data.map((perfRec) => {
                rec = {
                    secondGen: perfRec.secondGen ? [<i key="cell1" className="far fa-thumbs-up mr-2 green-text" aria-hidden="true"></i>] : [<i key="cell1" className="far fa-times-circle mr-2 red-text" aria-hidden="true"></i>],
                    unitCode: perfRec.unitCode,
                    unitName: perfRec.unitName,
                    managerName: perfRec.managerName,
                    unitStartDate: perfRec.unitStartDate,
                    unitEndDate: perfRec.unitEndDate,
                    reportedUnitSales: this.formatter.formatCurrency(perfRec.reportedUnitSales),
                    noPromoteOuts: perfRec.noPromoteOuts,
                    noDems: perfRec.noDems,
                    totalNoPersRecruits: perfRec.totalNoPersRecruits,
                    totalNoPersQualRecruits: perfRec.totalNoPersQualRecruits,
                    totalNoActPersRecruits: perfRec.totalNoActPersRecruits,
                    totalNoUnitRecruits: perfRec.totalNoUnitRecruits,
                    totalNoQualUnitRecruits: perfRec.totalNoQualUnitRecruits,
                    totalNoActUnitRecruits: perfRec.totalNoActUnitRecruits
                }
                demRecs.push(rec);
            });

            let tableData = {
                columns: [{
                    label: '2nd Gen Team Unit',
                    field: 'secondGen',
                    sort: 'asc'
                }, {
                    label: 'Unit Code',
                    field: 'unitCode',
                    sort: 'asc'
                },
                {
                    label: 'Unit Name',
                    field: 'unitName',
                    sort: 'asc'
                },
                {
                    label: 'Manager Name',
                    field: 'managerName',
                    sort: 'asc'
                }, {
                    label: 'Unit Start Date',
                    field: 'unitStartDate',
                    sort: 'asc'
                }, {
                    label: 'Unit End Date',
                    field: 'unitEndDate',
                    sort: 'asc'
                }, {
                    label: 'Unit Sales',
                    field: 'reportedUnitSales',
                    sort: 'asc'
                }, {
                    label: 'No P/O\'s',
                    field: 'noPromoteOuts',
                    sort: 'asc'
                }, {
                    label: 'No Dems',
                    field: 'noDems',
                    sort: 'asc'
                }, {
                    label: 'Personal Recruits',
                    field: 'totalNoPersRecruits',
                    sort: 'asc'
                }, {
                    label: 'Qualified Personal Recruits',
                    field: 'totalNoPersQualRecruits',
                    sort: 'asc'
                }, {
                    label: 'Active Personal Recruits',
                    field: 'totalNoActPersRecruits',
                    sort: 'asc'
                }, {
                    label: 'Unit Recruits',
                    field: 'totalNoUnitRecruits',
                    sort: 'asc'
                }, {
                    label: 'Qualified Unit Recruits',
                    field: 'totalNoQualUnitRecruits',
                    sort: 'asc'
                }, {
                    label: 'Active Unit Recruits',
                    field: 'totalNoActUnitRecruits',
                    sort: 'asc'
                }],
                rows: demRecs
            }
            this.setState({
                teamData: tableData,
                tableHidden: false
            });
            this.props.loaderOff();
        })

    }

    render() {

        return (
            <div>
                <Header headerText='Team Units Performance'
                    subHeaderText="(Click Go to load team units performance report for selected segment)"
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                <MDBRow>
                    <MDBCol md="6">
                        <MDBContainer>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="Year..."
                                        options={this.state.yearData}
                                        selected="Filter"
                                        getValue={this.handleYearSelectChange}
                                        required
                                    />
                                </MDBCol>

                            </MDBRow>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="Segment..."
                                        options={this.state.segmentData}
                                        selected="Filter"
                                        getValue={this.handleSegmentSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol>
                                    <MDBBtn onClick={this.getTeamPerformance}>Go</MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </MDBCol>

                    <MDBCol md="6">
                        <MDBContainer>
                            <DashboardLineGraph chartName="Team Sales Performance" graphData={this.state.teamGraphData} />
                        </MDBContainer>
                    </MDBCol>
                </MDBRow>

                <br />

                <div hidden={this.state.tableHidden}>
                    <hr />
                    <MDBContainer>
                        <MDBRow>
                            <div style={{ fontWeight: "bold" }}>Team Units Results<br />Segment - {this.state.selectedSegment}</div>
                        </MDBRow>
                        <MDBRow>
                            <div>(Showing unit performance results for selected segment)</div>
                        </MDBRow>
                    </MDBContainer>
                        <MDBDataTable
                        responsive
                        striped
                        bordered
                        hover
                        data={this.state.teamData}
                        paging={false}
                        autoWidth
                        maxHeight={"100px"}
                        />
                    
                        </div>
                    </MDBCardBody>
                    </MDBCard>
            </div>
        );
    }


}
